
import React from 'react';

import { Caption } from './typography';

export function WrestlerRecord({ wins = 0, losses = 0, streak = 0 }) {
  return (
    <Caption>
      {wins}W · {losses}L{streak ? ` · ${streak} streak` : ''}
    </Caption>
  );
}